import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,private auth: AuthService) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    //     if (this.auth.authenticated) {
    //         return true;
    //     } else {

    //         this.router.navigate(['/sessions/login'], { queryParams: { returnUrl: state.url }});
    //         return false;
    //     }
    // }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem('authkey') && localStorage.getItem('apikey')) {
            // logged in so return true
            return true;
        }

        // not logged in so redirect to login page with the return url
        // this.router.navigate(['/sessions/login'], { queryParams: { returnUrl: state.url }});
        this.router.navigate(['/sessions/login']);
        return false;
    }
}